module.exports = __webpack_public_path__ + "438a813d91c62730ae9cf3cc5fc70ff1.svg";